"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
var react_1 = __importStar(require("react"));
var Menu_1 = require("../Menu/MenuSuspenso/Menu");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var estiloBreadcrumb = require("./Breadcrumb.module.scss");
var Breadcrumb = function (_a) {
    var crumbs = _a.crumbs;
    var _b = (0, react_1.useState)(crumbs), crumbsAtualizados = _b[0], setCrumbsAtualizados = _b[1];
    var _c = (0, react_1.useState)(false), showMenu = _c[0], setShowMenu = _c[1];
    var _d = (0, react_1.useState)(null), hoverIndex = _d[0], setHoverIndex = _d[1];
    var dropdownRef = (0, react_1.useRef)(null);
    var handleMouseEnter = function (index) {
        setHoverIndex(index);
    };
    var handleMouseLeave = function () {
        setHoverIndex(null);
    };
    var handleDropdownClicado = function () {
        setShowMenu(function (prevShowMenu) { return !prevShowMenu; });
    };
    var handleClickOutside = function (e) {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setShowMenu(false);
        }
    };
    (0, react_1.useEffect)(function () {
        var novosCrumbs = crumbs.filter(function (_a) {
            var texto = _a.texto, icone = _a.icone;
            return texto || icone;
        }).map(function (crumb) { return (__assign({}, crumb)); });
        setCrumbsAtualizados(novosCrumbs);
    }, [crumbs]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var crumbsVisiveis = (crumbsAtualizados.length > 4 ? __spreadArray(__spreadArray([], crumbsAtualizados.slice(0, 2), true), [{ icone: "more_horiz", possuiDropdown: true, onClick: function () { return handleDropdownClicado(); }, }, __assign({}, crumbsAtualizados[crumbsAtualizados.length - 2]), __assign({}, crumbsAtualizados[crumbsAtualizados.length - 1]),], false) : crumbsAtualizados);
    var opcoesMenu = __spreadArray([], crumbsAtualizados.slice(2, crumbsAtualizados.length - 2), true);
    var menuAberto = (react_1.default.createElement(Menu_1.Menu, { regraTexto: function (item) { return "".concat(item.texto); }, tipoDoMenu: "actions", temMenuTip: false, onSelect: function (item) {
            setShowMenu(false);
            if (item && item.length > 0) {
                var selectedItem = item[0];
                if (selectedItem.onClick) {
                    selectedItem.onClick();
                }
            }
        }, opcoesMenu: opcoesMenu }));
    return (react_1.default.createElement("nav", { className: estiloBreadcrumb.breadcrumb }, crumbsVisiveis.map(function (crumb, index) {
        var ultimoCrumb = index === crumbsVisiveis.length - 1;
        var coloracao = hoverIndex === index
            ? (ultimoCrumb ? Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600 : Cores_1.Cores.CoresIdentidadeMU.azulMu)
            : (ultimoCrumb ? Cores_1.Cores.CoresIdentidadeMU.azulMu : Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        return (react_1.default.createElement("ol", { className: "".concat(estiloBreadcrumb.conteudo, "\n                        ").concat(ultimoCrumb
                ? estiloBreadcrumb.ultimoCrumb
                : estiloBreadcrumb.desativado, "\n                        "), key: index, onClick: function () { return crumb.onClick && crumb.onClick(); } },
            react_1.default.createElement("li", { className: estiloBreadcrumb.cadaCrumb, onMouseEnter: function () { return handleMouseEnter(index); }, onMouseLeave: handleMouseLeave },
                react_1.default.createElement(Icone_1.Icone, { nome: crumb.icone, altura: "14px" }),
                react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: "pointer" }, cor: coloracao, tipo: "breadcrumb" }, crumb.texto),
                crumb.possuiDropdown && showMenu && (react_1.default.createElement("div", { className: estiloBreadcrumb.dropdown, onClick: handleDropdownClicado, ref: dropdownRef }, menuAberto)),
                !ultimoCrumb && (react_1.default.createElement(Icone_1.Icone, { nome: "keyboard_double_arrow_right", desabilitado: true, altura: "24px" })))));
    })));
};
exports.Breadcrumb = Breadcrumb;
